import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedIcon = _resolveComponent("FriedIcon");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['checkbox-field', { checked: _ctx.checked }])
    }, [
        (_ctx.checked)
            ? (_openBlock(), _createBlock(_component_FriedIcon, {
                key: 0,
                icon: "check-mark",
                class: "check-icon"
            }))
            : _createCommentVNode("", true)
    ], 2));
}
